var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSyncaroo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0DABE",
    d: "M19.448 4.28c.132-.456.666-.72 1.082-.49a.65.65 0 0 1 .29.822c-.198.477-.484 1.145-.66 1.448-.224.389-.628.96-.927 1.37a.713.713 0 0 1-.921.201c-.418-.231-.496-.8-.177-1.156.312-.348.662-.771.872-1.129.198-.335.34-.721.44-1.066Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0F11",
    d: "M21.557 3.622c0 .62-.508 1.123-1.134 1.123a1.13 1.13 0 0 1-1.134-1.123c0-.62.508-1.122 1.134-1.122s1.134.502 1.134 1.122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0DABE",
    d: "M4.553 4.28c-.132-.456-.666-.72-1.083-.49a.65.65 0 0 0-.29.822c.198.477.485 1.145.66 1.448.224.389.629.96.927 1.37a.713.713 0 0 0 .922.201c.418-.231.496-.8.176-1.156-.312-.348-.661-.771-.872-1.129a4.7 4.7 0 0 1-.44-1.066"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0F11",
    d: "M2.444 3.622c0 .62.508 1.123 1.134 1.123s1.134-.503 1.134-1.123S4.204 2.5 3.578 2.5s-1.134.502-1.134 1.122"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#23201E",
    d: "M23.5 14.525c0 5.49-5.149 6.975-11.5 6.975S.5 20.016.5 14.525s5.149-9.38 11.5-9.38 11.5 3.89 11.5 9.38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0DABE",
    d: "M20.099 14.16c0 3.821-3.626 4.854-8.099 4.854s-8.099-1.033-8.099-4.854 3.221-5.327 7.694-5.327S20.1 10.338 20.1 14.16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0F11",
    d: "M18.155 13.883c0 .886-.725 1.604-1.62 1.604-.894 0-1.62-.718-1.62-1.604 0-.885.726-1.603 1.62-1.603s1.62.718 1.62 1.603m-9.07 0c0 .886-.726 1.604-1.62 1.604s-1.62-.718-1.62-1.604c0-.885.725-1.603 1.62-1.603.894 0 1.62.718 1.62 1.603"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSyncaroo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/syncaroo.f8881da9.svg";